import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84603f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "TDadosResponsabilidadeUsuario",
  "data-testid": "TDadosResponsabilidadeUsuario"
}
const _hoisted_2 = { class: "TDadosResponsabilidadeUsuario__DadosAcesso" }
const _hoisted_3 = { class: "TDadosResponsabilidadeUsuario__Acordeao" }

import { MInput, MDropdown } from "@/components/Gerais"
  import Accordion from "primevue/accordion"
  import AccordionTab from "primevue/accordiontab"
  import { OAcordeaoProjetos } from "@/components/Projetos"
  import { OAcordeaoProfissionais } from "@/components/Profissionais"

  import { opcoesPerfisDeOrganizacao } from "@/store/listaUsuarios"
  import useVuelidate from "@vuelidate/core"
  import { helpers, required } from "@vuelidate/validators"
  import { usuariosStore } from "@/store/listaUsuarios"
  import { storeToRefs } from "pinia"
  import { useI18n } from "vue-i18n"

  interface Props {
    escopoValidacao?: string
    alteracaoDeSenha: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ODadosResponsabilidadeUsuario',
  props: {
    escopoValidacao: null,
    alteracaoDeSenha: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    escopoValidacao?: string
    alteracaoDeSenha: boolean
  }

  

  const { t } = useI18n()

  const store = usuariosStore()
  const { email, senha, perfilDeOrganizacao } = storeToRefs(store)

  let regras
  let v$

  if (!props.alteracaoDeSenha) {
    regras = {
      email: {
        obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
      },
      senha: {
        obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
      },
      perfilDeOrganizacao: {},
    }

    v$ = useVuelidate(
      regras,
      { email, senha, perfilDeOrganizacao },
      { $scope: props.escopoValidacao }
    )
  } else {
    regras = {
      email: {
        obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
      },
      perfilDeOrganizacao: {},
    }

    v$ = useVuelidate(
      regras,
      { email, perfilDeOrganizacao },
      { $scope: props.escopoValidacao }
    )
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(MInput), {
        modelValue: _unref(v$).email.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).email.$model) = $event)),
        autocompletar: "off",
        class: _normalizeClass(["TDadosResponsabilidadeUsuario__Email", { 'p-invalid': _unref(v$).email.$invalid }]),
        "data-testid": "TDadosResponsabilidadeUsuario__Email",
        label: _unref(t)('emailDeAcesso'),
        "mensagem-de-erro": _unref(v$).email.$errors[0]?.$message,
        nome: "email",
        obrigatorio: "",
        "tipo-entrada": "text"
      }, null, 8, ["modelValue", "class", "label", "mensagem-de-erro"]),
      (__props.alteracaoDeSenha)
        ? (_openBlock(), _createBlock(_unref(MInput), {
            key: 0,
            modelValue: _unref(senha),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(senha) ? (senha).value = $event : null)),
            class: "TDadosResponsabilidadeUsuario__Senha",
            "data-testid": "TDadosResponsabilidadeUsuario__Senha",
            label: _unref(t)('novaSenha'),
            nome: "senha",
            "tipo-entrada": "password"
          }, null, 8, ["modelValue", "label"]))
        : (_openBlock(), _createBlock(_unref(MInput), {
            key: 1,
            modelValue: _unref(v$).senha.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).senha.$model) = $event)),
            autocompletar: "off",
            class: _normalizeClass(["TDadosResponsabilidadeUsuario__Senha", { 'p-invalid': _unref(v$).senha.$invalid }]),
            "data-testid": "TDadosResponsabilidadeUsuario__Senha",
            label: _unref(t)('senha'),
            "mensagem-de-erro": _unref(v$).senha.$errors[0]?.$message,
            nome: "senha",
            obrigatorio: "",
            "tipo-entrada": "password"
          }, null, 8, ["modelValue", "class", "label", "mensagem-de-erro"])),
      _createVNode(_unref(MDropdown), {
        modelValue: _unref(v$).perfilDeOrganizacao.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).perfilDeOrganizacao.$model) = $event)),
        class: "TDadosResponsabilidadeUsuario__PerfilDeOrganizacao",
        "data-testid": "TDadosResponsabilidadeUsuario__PerfilDePermissao",
        filtro: false,
        "option-label": "nome",
        "option-value": "id",
        options: _unref(opcoesPerfisDeOrganizacao),
        placeholder: _unref(t)('perfilDePermissaoNaOrganizacao')
      }, null, 8, ["modelValue", "options", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      false
        ? (_openBlock(), _createBlock(_unref(Accordion), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(AccordionTab), { header: "projetos" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(OAcordeaoProjetos))
                ]),
                _: 1
              }),
              _createVNode(_unref(AccordionTab), { header: "profissionais e usuários" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(OAcordeaoProfissionais))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})